import { goBack, HubbleRoute, pushPage } from "../../shared_states/modal";
import { PhosphorIcon } from "../../widgets/icons";
import { RedemptionTransactions } from "../transactions/transactions";
import { HelpAndSupport } from "./help_and_support";
import { Match, Show, Switch } from "solid-js";
import { logout } from "../../data/auth";
import { sdkEventManager } from "~/data/events";
import { clearCookie } from "~/utils/client_cookie";
import { Cookie } from "~/types";
import { useClassicContext } from "~/data/classic/classic_context";
import { PayoutsPage } from "../bank_transfer/payouts";
import { showHelpAndSupportFAQsTab } from "~/data/partner_config";

export function HomeMenu() {
  const { data, login } = useClassicContext();
  const clientConfig = data.isLoggedIn ? data.clientConfig : null;

  const clientId = data.clientId;

  return (
    <div class="flex flex-col rounded-t-[20px] bg-baseTertiaryLight p-5 pb-0">
      <Switch>
        <Match when={data.isLoggedIn}>
          <div
            class="body-normal flex cursor-pointer select-none items-center gap-4 border-b-[1px] border-baseTertiaryMedium py-4"
            onClick={() => {
              goBack(() => {
                pushPage(
                  () => <RedemptionTransactions />,
                  undefined,
                  HubbleRoute.TRANSACTIONS
                );
              });
            }}
          >
            <PhosphorIcon name="list-checks" />
            <span>My Brand Cards</span>
          </div>
        </Match>
        <Match when={true}>
          <div
            class="body-normal flex cursor-pointer select-none items-center gap-4 border-b-[1px] border-baseTertiaryMedium py-4"
            onClick={() => {
              goBack(() => {
                login(() => {});
              });
            }}
          >
            <PhosphorIcon name="sign-in" />
            <span>Login</span>
          </div>
        </Match>
      </Switch>

      <Show when={clientConfig?.payoutsEnabled}>
        <div
          class="body-normal flex cursor-pointer select-none items-center gap-4 border-b-[1px] border-baseTertiaryMedium py-4"
          onClick={() => {
            goBack(() => {
              pushPage(
                () => <PayoutsPage />,
                undefined,
                HubbleRoute.BANK_TRANSFER_PAYOUTS
              );
            });
          }}
        >
          <PhosphorIcon name="list-checks" />
          <span>My Payouts</span>
        </div>
      </Show>

      <Show when={showHelpAndSupportFAQsTab(clientId)}>
        <div
          class="body-normal flex cursor-pointer select-none items-center gap-4 border-b-[1px] border-baseTertiaryMedium py-4"
          onClick={() => {
            goBack(() => {
              pushPage(
                () => <HelpAndSupport />,
                undefined,
                HubbleRoute.HELP_AND_SUPPORT
              );
            });
          }}
        >
          <PhosphorIcon name="chat-dots" />
          <span>Help & Support</span>
        </div>
      </Show>

      <Show when={data.isLoggedIn && data.mode == "hubble"}>
        <div
          class="body-normal flex cursor-pointer select-none items-center gap-4 border-b-[1px] border-baseTertiaryMedium py-4"
          onClick={async () => {
            clearCookie(Cookie.SessionId);
            logout().then(() => {
              goBack();
            });
          }}
        >
          <PhosphorIcon name="sign-out" />
          <span>Logout</span>
        </div>
      </Show>
    </div>
  );
}
